import { useEffect } from "react";
import useEntities from "../../app/hooks/useEntities";
import useTableData from "../../app/hooks/useTableData";
import { useAppSelector } from "../../app/store";
import Filter from "../../components/filter";
import GlobalSearch from "../../components/global-search";
import Grid from "../../components/grid";
import { AppContainer } from "../../styles";
import { DarkmodeStyle } from "../../styles/darkmode";

export default function TablePage() {
  const { filter } = useAppSelector(store => store.AppSlice)
  const { getData: getTableData, loading } = useTableData()
    console.log(filter)
  useEntities()

  useEffect(getTableData, [filter, getTableData])

  return (
    <AppContainer>
      <DarkmodeStyle />
      <Filter />
      <GlobalSearch />
      <Grid loading={loading} />
    </AppContainer>
  );
}
